
import React, { Component } from 'react';

import {connect} from 'react-redux';
import {Field, reduxForm} from 'redux-form';

import { getItemsPerDates } from '../../actions/itemAction'
import { GetIssuesByItems } from '../../actions/issueAction'


import { Button, Checkbox, Grid, IconButton, Popover, Slide, TextField } from '@material-ui/core';
import { renderLegacyRepairDatePicker, renderSwitchV4 } from '../../utils/engageComponents';
import { CheckBox, CheckBoxOutlineBlank } from '@material-ui/icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { Autocomplete } from '@material-ui/lab';
import moment from 'moment';


const options=['7 Days', '2 Weeks', '30 Days'];

const responseOptions = ['Greater than', 'Less than', 'Between']
const responseUnits = ['days', 'hours', 'minutes']


class RepairsFilters extends Component {
    constructor(props){
        super(props);
        this.state={
            tab: (this.props.tab)? this.props.tab : 1 ,
            statusSelected:(this.props.filters && this.props.filters.statusSelected)? this.props.filters.statusSelected: [],
            dateChanged:(this.props.filters && this.props.filters.dateChanged)? this.props.filters.dateChanged : false,
            dateOptionSelected:(this.props.filters && this.props.filters.dateOptionSelected)? this.props.filters.dateOptionSelected : null,
            startDate: (this.props.filters && this.props.filters.startDate)? this.props.filters.startDate : new Date(),
            endDate:  (this.props.filters && this.props.filters.endDate)? this.props.filters.endDate : new Date(),
            itemsSelected:(this.props.filters && this.props.filters.itemsSelected)? this.props.filters.itemsSelected : [],
            responseTime:(this.props.filters)? this.props.filters.responseTime : false,
            responseOption:(this.props.filters && this.props.filters.responseOption)? this.props.filters.responseOption : responseOptions[0],
            lowerLimit:(this.props.filters && this.props.filters.lowerLimit)? this.props.filters.lowerLimit : 1,
            upperLimit: (this.props.filters && this.props.filters.upperLimit)? this.props.filters.upperLimit : 10,
            issuesSelected:(this.props.filters && this.props.filters.issuesSelected)? this.props.filters.issuesSelected : [],
            responseUnit:(this.props.filters && this.props.filters.responseUnit)? this.props.filters.responseUnit : responseUnits[1]

           
        }    

    };

    componentDidMount(){        
        this.getItems();
        this.getIssues()
    }

    getItems = async ()=>{
        const id = localStorage.getItem('communityId')

        const options = {
            dateOptionSelected: this.state.dateOptionSelected,
            dateChanged:this.state.dateChanged,
            startDate:this.state.startDate,
            endDate:this.state.endDate
        }

        const newItems = await this.props.getItemsPerDates(id, options)

        const selectedItems = this.state.itemsSelected;

        if(selectedItems.length>0){ //If we had items already selected is possible that those items aren't include in the new date range selected
            //remove the items that aren't in our current items arr 
            const arrFiltered = selectedItems.filter(t=>newItems.find(i=>i._id===t))

            this.setState({itemsSelected:arrFiltered}, ()=>this.getIssues())

        }

    }

    getIssues=async()=>{
        const id = localStorage.getItem('communityId')

        const newIssues = await this.props.GetIssuesByItems(id, this.state.itemsSelected)

        const selectedIssues = this.state.issuesSelected;


        if(selectedIssues.length>0){ //If we had items already selected is possible that those items aren't include in the new date range selected
            //remove the items that aren't in our current items arr 
            const arrFiltered = selectedIssues.filter(x=>newIssues.find(i=>i._id===x))

            this.setState({issuesSelected:arrFiltered})

        }
    }


    setRepairsDate(date, type) {

        const upd={
            startDate:this.state.startDate,
            endDate:this.state.endDate,
            dateChanged:true,
            dateOptionSelected:null
        }

        if(type==='start'){

            if(date>this.state.endDate){
                const add1Day=moment(date).add(1,'day')

                upd.startDate = date;
                upd.endDate = add1Day

            }else{
                upd.startDate = date;
            }
           

        }else if(type==='end'){
        
            if(date<this.state.startDate){
                const remove1Day=moment(date).subtract(1,'day')

                upd.endDate = date;
                upd.startDate = remove1Day                

            }else{
                upd.endDate = date;
            }
        }

        this.setState(upd, ()=>this.getItems())

    }


    handleSelectValue = (value) =>{

        const arr = this.state.statusSelected;

        const item = arr.find(item =>item===value);

        if (!item) {
            arr.push(value)
        }
        else {
            const indexToDelete = arr.indexOf(value);
            arr.splice(indexToDelete, 1);

        }

        this.setState({ statusSelected: arr });

    }

    handleSelectOption=(e,op)=>{

        this.setState({
            dateOptionSelected:op,
            dateChanged:false,
            startDate: new Date(),
            endDate: new Date()
        }, ()=>this.getItems())

    }

    CheckForValidCaracters = (input) => {
        let pattern = '[0-9]';

        if (input.length > 0) {
            var regex = new RegExp(pattern);
            if (regex.test(input)) {
                return input;
            } else {
                return input.substring(0, input.length - 1);
            }
        } else {
            return input;
        }

    };

    handleSelectItem = (item) =>{

        const arr = this.state.itemsSelected;

        const obj = arr.find(x=>x===item);

        if (!obj) {

            arr.push(item)

        }else {
            const indexToDelete = arr.indexOf(item);
            arr.splice(indexToDelete, 1);

        }

        this.setState({ itemsSelected: arr }, ()=>this.getIssues());

    }

    
    handleSelectIssue = (issue) =>{

        const arr = this.state.issuesSelected;

        const obj = arr.find(x=>x===issue);

        if (!obj) {

            arr.push(issue)

        }else {
            const indexToDelete = arr.indexOf(issue);
            arr.splice(indexToDelete, 1);

        }


        this.setState({ issuesSelected: arr });

    }
   
    resetfilter=()=>{
        this.setState({
            statusSelected:[],
            dateChanged:false,
            dateOptionSelected: '',
            startDate: new Date(),
            endDate: new Date(),
            itemsSelected: [],
            issuesSelected: [],
            responseTime: false,
            responseOption: 'Greater than',
            lowerLimit: 1,
            upperLimit: 10,
            responseUnit:'hours'
        }, ()=>{
            this.props.resetFilters();
            this.getItems()
        })
    }

    handleApplyFilters = ()=>{
        const filtersToSend = {...this.state}
        this.props.applyFilters(filtersToSend)
        this.props.onClose();
    }

    render() {
        return (
            <>
                <Popover
                    id="ActivityFilterPopOver"
                    open={true}
                    onClose={this.props.onClose}
                    anchorEl={this.props.anchorEl}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'center',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'center',
                    }}
                        
                    PaperProps={{
                        className:'Lrepairs_filters_popover',
                    }}
                    elevation={0}
                >
                    <Slide in={true} direction='left' timeout={600} mountOnEnter unmountOnExit>
                        <Grid container xs={12} className='Lrepairs_filters_slide'>
                            <form style={{width:'100%'}}>

                                {/* Title and close icon */}
                                <Grid item container xs={12} justifyContent='space-between' alignItems='center'>
                                    <Grid item className='filters_title'>Filters</Grid>

                                    <IconButton onClick={()=>this.props.onClose()}>
                                        <img
                                            src='https://engage360.s3.amazonaws.com/Icons/Categories/times-circle.svg'
                                            alt='close_icon'
                                            width='32px'
                                            height='32px'
                                            style={{fontWeight:'bold'}}
                                            className='logo-black'
                                        />
                                    </IconButton>
                                </Grid>

                                {/* Apply filters buttons */}
                                <Grid item container xs={12}>
                                    <Button className="filters_btn" onClick={this.handleApplyFilters}>Apply Current Filters</Button>
                                    <Button className='Lfilters_clear_btn' onClick={this.resetfilter}>Clear All</Button>
                                </Grid>

                                {/* Status only shown in tab 1 */}
                                {
                                    this.state.tab === 1 &&
                                    <Grid item container xs={12} justifyContent='flex-start'>
                                        <Grid item xs={12} className='filters_subtitles sectionMargin'>Status</Grid>
                                        
                                        {/* Opened */}
                                        <Grid item container id={`status_opened`} className="category_box_wrapper"
                                            style={{marginRight:'2%'}}
                                        >
                                            <Grid item container justifyContent='center' 
                                                className={this.state.statusSelected.find(i=>i==='pending')?'Lfilters_category_box_selected':'Lfilters_category_box'}
                                                onClick={()=>this.handleSelectValue('pending')}
                                            >
                                                <Grid item container xs={12} justifyContent='center'>
                                                    <Checkbox
                                                        checked={this.state.statusSelected.find(i=>i==='pending')?true:false}
                                                        onChange={(e) => this.handleSelectValue('pending') }
                                                        onClick={(e) => e.stopPropagation()}
                                                        icon={<CheckBoxOutlineBlank/>}
                                                        checkedIcon={<CheckBox style={{color:'white'}}/>}
                                                        id={`status__checkbox_Opened`}
                                                    />
                                                </Grid>
                                           
                                                <Grid className="ligth_txt" style={{textAlign:'center'}}>Opened</Grid>
                                            </Grid>
                                        </Grid>

                                        <Grid item container id={`status_Scheduled`} className="category_box_wrapper"
                                            style={{marginRight:'2%'}}
                                        >
                                            <Grid item container justifyContent='center' 
                                                className={this.state.statusSelected.find(i=>i==='scheduled')?'Lfilters_category_box_selected':'Lfilters_category_box'}
                                                onClick={()=>this.handleSelectValue('scheduled')}
                                            >
                                                <Grid item container xs={12} justifyContent='center'>
                                                    <Checkbox
                                                        checked={this.state.statusSelected.find(i=>i==='scheduled')?true:false}
                                                        onChange={(e) => this.handleSelectValue('scheduled') }
                                                        onClick={(e) => e.stopPropagation()}
                                                        icon={<CheckBoxOutlineBlank/>}
                                                        checkedIcon={<CheckBox style={{color:'white'}}/>}
                                                        id={`status__checkbox_Scheduled`}
                                                    />
                                                </Grid>
                                           
                                                <Grid className="ligth_txt" style={{textAlign:'center'}}>Scheduled</Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                            
                                }

                                {/* Date ranges */}
                                <Grid item container xs={12} justifyContent='space-between'>
                                    <Grid item xs={12} className='filters_subtitles sectionMargin'>Date Range</Grid>

                                    {/* Date range */}
                                    <Grid item className={!this.state.dateChanged? 'Ldate_range_box' :'date_range_box_selected'}>
                                        <Field
                                            name="startDate"
                                            labelDate="From"
                                            selectedDate={this.state.startDate} //most be an date object is use in both date and time
                                            onDateChange={(date) => this.setRepairsDate(date, 'start')}
                                            maxLength={20}
                                            component={renderLegacyRepairDatePicker}
                                            idToSet='filters_date'
                                            id='repairs_filters_date'
                                            active={this.state.dateChanged? true : false}
                                        />
                                    </Grid>

                                    <Grid item className={!this.state.dateChanged? 'Ldate_range_box' :'date_range_box_selected'}>
                                        <Field
                                            name="endDate"
                                            labelDate="To"
                                            selectedDate={this.state.endDate} //most be an date object is use in both date and time
                                            onDateChange={(date) => this.setRepairsDate(date, 'end')}
                                            maxLength={20}
                                            component={renderLegacyRepairDatePicker}
                                            idToSet='filters_end_date'
                                            id='repairs_filters_end_date'
                                            active={this.state.dateChanged? true : false}

                                        />
                                    </Grid>


                                    {/* Dates Fixed Options */}
                                    <Grid item xs={12} className='ligth_txt sectionMargin'>Or the past</Grid>

                                    {
                                        options.map((op, index)=>{
                                            return(
                                                <Grid item key={`option_${index}`} 
                                                    onClick={(e)=>this.handleSelectOption(e,op, true)}
                                                    className={(this.state.dateOptionSelected===op)? 'ligth_txt option_box_selected' : 'ligth_txt Loption_box' }
                                                    style={{
                                                        color:(this.state.dateOptionSelected)?'#009EDD':'#707070', 
                                                        border:(this.state.dateOptionSelected)?'2px solid #009EDD':'2px solid #707070'
                                                    }} 
                                                >
                                                    {op}
                                                </Grid>
                                            )
                                        })
                                    }


                                </Grid>

                                {/* Response time only in completed tab*/}
                                {
                                    this.state.tab === 2 &&
                                    <Grid item container xs={12} className='sectionMargin'>
                                        <Grid item xs={12} className='filters_subtitles'>Response time</Grid>

                                        {/* Range between response */}
                                        <Grid item container xs={12} className="sectionMargin" alignItems='center'>
                                            <Grid item xs={2}>
                                                <Field
                                                    idToSet='response_time_Switch'
                                                    name="Response time"
                                                    checked={this.state.responseTime}
                                                    onClick={()=>this.setState(prevState=>({ responseTime: !prevState.responseTime }))}
                                                    component={renderSwitchV4}
                                                />
                                            </Grid>
                                        
                                            <Grid item container xs={10} className="ligth_txt" alignItems='center'>

                                            <Autocomplete
                                                id='response_time_dropdown'
                                                style={{width:'65%'}}
                                                options={responseOptions}
                                                value={this.state.responseOption}
                                                name="Response time"
                                                getOptionSelected={(option, value) => option === value ? true : false}
                                                getOptionLabel={option => option}
                                                disableClearable
                                                renderOption={option => {
                                                    return (
                                                        <Grid item container xs={12}>
                                                            <Grid item xs={1}>
                                                                {
                                                                    this.state.responseOption === option &&
                                                                    <FontAwesomeIcon
                                                                        icon={faCheck}
                                                                        color='black'
                                                                        size='1x'
                                                                    />
                                                                }
                                                            </Grid>
                                                        
                                                            <span style={{ marginLeft: '10px', fontFamily: 'Gotham-Book', fontSize: '16px', color:'black' }}>{option}</span>
                                                        </Grid>
                                                    )
                                                }}
                                                classes={{
                                                    listbox:"responseTimeAutocompleteListbox"
                                                }}
                                                renderInput={(params) => {
                                                    return (<>
                                                        <TextField
                                                            {...params}
                                                            className='Lresponse_time_select'
                                                            style={{fontSize:'14px'}}
                                                            InputProps={{ ...params.InputProps, disableUnderline:true, classes:{input:'txt_black'} }}
                                                        />
                                                    </>
                                                    )
                                                }}
                                                clearOnEscape={true}
                                                onChange={(e, newItem)=>{
                                                    this.setState({responseOption: newItem, responseTime:true})
                                                
                                                }}
                                            />

                                                {
                                                    this.state.responseOption===responseOptions[0]?
                                                    <TextField
                                                        name='greater_than'
                                                        value={this.state.lowerLimit}
                                                        onChange={(e)=>{
                                                            const input = this.CheckForValidCaracters(e.target.value);
                                                            this.setState({lowerLimit: input, responseTime: (input.length>0)? true: false})
                                                        }}
                                                        className='registrations_txt'
                                                        classes={{
                                                            input:"registrations_txt-root"
                                                        }}
                                                        inputProps={{
                                                            className:'txt_black'
                                                        }}
                                                    />
                                                    :
                                                    this.state.responseOption===responseOptions[1]?
                                                    <TextField
                                                        name='less_than'
                                                        value={this.state.upperLimit}
                                                        onChange={(e)=>{
                                                            const input = this.CheckForValidCaracters(e.target.value);
                                                            this.setState({upperLimit: input, responseTime: (input.length>0)? true: false})
                                                        }}
                                                        className='registrations_txt'
                                                        classes={{
                                                            input:"registrations_txt-root"
                                                        }}
                                                        inputProps={{
                                                            className:'txt_black'
                                                        }}

                                                    />
                                                    :
                                                    this.state.responseOption===responseOptions[2]?
                                                    <>
                                                        <TextField
                                                            name='lower_limit'
                                                            value={this.state.lowerLimit}
                                                            onChange={(e)=>{
                                                                const input = this.CheckForValidCaracters(e.target.value);
                                                                this.setState({lowerLimit: input, responseTime: (input.length>0)? true: false})
                                                            }}
                                                            className='registrations_txt'
                                                            classes={{
                                                                input:"registrations_txt-root"
                                                            }}
                                                            inputProps={{
                                                                className:'txt_black'
                                                            }}
                                                        />
                                                        &
                                                        <TextField
                                                            name='under_limit'
                                                            value={this.state.upperLimit}
                                                            onChange={(e)=>{
                                                                const input = this.CheckForValidCaracters(e.target.value);
                                                                this.setState({upperLimit:input, responseTime:(input.length>0)? true: false})
                                                            }}
                                                            className='registrations_txt'
                                                            classes={{
                                                                input:"registrations_txt-root"
                                                            }}
                                                            inputProps={{
                                                                className:'txt_black'
                                                            }}

                                                        />
                                                    
                                                    </>
                                                    :
                                                    undefined
                                                }

                                                <Autocomplete
                                                    id='response_time_units_dropdown'
                                                    style={{width:'50%', marginTop:'0.5rem'}}
                                                    options={responseUnits}
                                                    value={this.state.responseUnit}
                                                    name="Response Unit"
                                                    getOptionSelected={(option, value) => option === value ? true : false}
                                                    getOptionLabel={option => option}
                                                    disableClearable
                                                    renderOption={option => {
                                                        return (
                                                            <Grid item container xs={12}>
                                                                <Grid item xs={1}>
                                                                    {
                                                                        this.state.responseUnit === option &&
                                                                        <FontAwesomeIcon
                                                                            icon={faCheck}
                                                                            color='black'
                                                                            size='1x'
                                                                        />
                                                                    }
                                                                </Grid>
                                                            
                                                                <span style={{ marginLeft: '10px', fontFamily: 'Gotham-Book', fontSize: '16px', color:'black' }}>{option}</span>
                                                            </Grid>
                                                        )
                                                    }}
                                                    classes={{
                                                        listbox:"responseTimeAutocompleteListbox"
                                                    }}
                                                    renderInput={(params) => {
                                                        return (<>
                                                            <TextField
                                                                {...params}
                                                                className='Lresponse_time_select'
                                                                style={{fontSize:'14px'}}
                                                                InputProps={{ ...params.InputProps, disableUnderline:true, classes:{input:'txt_black'} }}
                                                            />
                                                        </>
                                                        )
                                                    }}
                                                    clearOnEscape={true}
                                                    onChange={(e, newItem)=>{
                                                        this.setState({responseUnit: newItem, responseTime:true})
                                                    
                                                    }}
                                                />

                                            </Grid>
                                        </Grid>
                                    </Grid>

                                }
                            
                                {/* Items filters */}
                                <Grid item container xs={12} justifyContent='flex-start' className='sectionMargin'>
                                    <Grid item xs={12} className='filters_subtitles'>Item</Grid>
                                    {
                                        this.props.items && this.props.items.map((item, index)=>{

                                            const isSelected = this.state.itemsSelected.find(i=>i===item._id)

                                            return(
                                                <Grid item container key={item._id} id={`item_${item._id}`} className="category_box_wrapper"
                                                    style={{marginRight:((index+1)%3===0)?'0%':'2%'}}
                                                >
                                                <Grid item container justifyContent='center' 
                                                    className={isSelected?'Lfilters_category_box_selected':'Lfilters_category_box'} 
                                                    onClick={()=>this.handleSelectItem(item._id)}
                                                >
                                                    <Grid item container xs={12} justifyContent='flex-end'>
                                                        <Checkbox
                                                            checked={isSelected?true:false}
                                                            onChange={(e) => this.handleSelectItem(item._id) }
                                                            onClick={(e) => e.stopPropagation()}
                                                            icon={<CheckBoxOutlineBlank/>}
                                                            checkedIcon={<CheckBox style={{color:'white'}}/>}
                                                            id={`item_checkbox_${item._id}`}
                                                        />
                                                    </Grid>
                                                    <Grid item container xs={12} justifyContent='center'>
                                                        <img
                                                            src={item.iconUrl}
                                                            alt={`item_icon_${item.name}`}
                                                            width='32px'
                                                            height='32px'
                                                            className={!isSelected&&"logo-black"}
                                                        />
                                                    </Grid>
                                               
                                                    <Grid className="ligth_txt" style={{textAlign:'center'}}>{item.name}</Grid>
                                                </Grid>
                                                </Grid>
                                            )
                                        })
                                    }
                                </Grid>
                                
                                {/* Issues filters */}
                                <Grid item container xs={12} justifyContent='flex-start' className='sectionMargin'>
                                    {
                                        this.props.issues && this.props.issues.length>0?
                                        <Grid item xs={12} className='filters_subtitles'>Issue</Grid>
                                        :
                                        ''
                                    }
                                    {
                                        this.props.issues && this.props.issues.map((issue)=>{

                                            const isSelected = this.state.issuesSelected.find(i=>i===issue._id)

                                            return(
                                                <Grid item container xs={12} key={issue._id} id={`issue_${issue._id}`} 
                                                    alignItems='center' onClick={()=>this.handleSelectIssue(issue._id)}
                                                    style={{cursor:'pointer'}}    
                                                >
                                                    <Checkbox
                                                        checked={isSelected?true:false}
                                                        onChange={(e) => this.handleSelectIssue(issue._id) }
                                                        onClick={(e) => e.stopPropagation()}
                                                        icon={<CheckBoxOutlineBlank fontSize='large' style={{color:'black'}}/>}
                                                        checkedIcon={<CheckBox fontSize='large' style={{color:'#009EDD'}}/>}
                                                        id={`issue_checkbox_${issue._id}`}
                                                    />

                                                    <Grid style={{fontFamily:isSelected?'Gotham-Bold':'Gotham-Book', fontSize:'16px' }}>{issue.name}</Grid>                       
                                                </Grid>
                                            )
                                        })
                                    }

                                </Grid>


                                {/* Apply filters button */}
                                <Grid item container xs={12} className='sectionMargin'>
                                    <Button className="filters_btn" onClick={this.handleApplyFilters}>Apply Current Filters</Button>
                                </Grid>

                            </form>
                        </Grid>
                    </Slide>
                </Popover>
            
            </>
        )
    }
}

function mapStateToProps(state){
    const items = (state.itemReducer && state.itemReducer.itemsFiltered)? state.itemReducer.itemsFiltered : [];
    const issues = (state.issueReducer && state.issueReducer.itemsIssues)? state.issueReducer.itemsIssues : [];

    return{
       items,
       issues
    };
}


export default connect(mapStateToProps,{ getItemsPerDates, GetIssuesByItems })(reduxForm({
    form: 'RepairsFilters',
})(RepairsFilters));

